import React from 'react'
import {NavLink} from 'react-router-dom'
import {useSelector} from "react-redux";


function Navbar() {
    const state = useSelector((state)=> state.handleCart)
    return (
        <>
            <nav className="navbar navbar-expand-lg bg-white py-3 shadow-sm">
                <div className="container">
                    <NavLink className="navbar-brand fw-bold fs-2" to="/" >React Collection</NavLink>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <NavLink className="nav-link active" aria-current="page" to="/">Home</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/products">Products</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/about">About</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/contact">Contact</NavLink>
                            </li>
                        </ul>
                        <div className='buttons'>
                            {/* <NavLink to='/login' className='btn btn-outline-dark'>
                                <i className="fa-solid fa-right-to-bracket me-2"></i> Log In
                            </NavLink>
                            <NavLink to='/Register' className='btn btn-outline-dark ms-2'>
                                <i className="fa-solid fa-user-plus me-2"></i> Register
                            </NavLink> */}
                            <NavLink to='/cart' className='btn btn-outline-dark ms-2'>
                            <i className="fa fa-cart-shopping me-2"></i> Cart ({state.length})
                            </NavLink>

                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Navbar;